<h3 class="cdk-visually-hidden">{{ i18nKeys.FilterBar.Title | translate }}</h3>

<ng-content select="[topSlot]" />

@if (initialized$ | async) {
	<form [formGroup]="form">
		@for (group of filters | keyvalue; track group) {
			<div class="c-filter-bar__facet" [formGroupName]="group.key">
				<h5 class="c-filter-bar__facet__title">
					{{
						(i18nKeys.FilterBar.Facets | hasOwnProperty: group.key)
							? (i18nKeys.FilterBar.Facets[group.value.name] | translate)
							: group.value.name
					}}

					@if (group.key === FAVORITE_PRODUCTS_FACET_ID) {
						<cjm-info
							[description]="
								associationName
									? (i18nKeys.FilterBar.Facets.FavoriteProductsTooltip.AsAssociation
										| translate: { associationName: associationName })
									: (i18nKeys.FilterBar.Facets.FavoriteProductsTooltip.AsPublic | translate)
							"
						/>
					}
				</h5>

				<ul class="c-filter-bar__facet__list">
					@for (option of group.value.options | keyvalue; track option) {
						<li
							class="c-filter-bar__facet__list__item"
							cypressTag="FilterBar.UnrefinableFacets.Item"
							[ngClass]="{
								'c-filter-bar__facet__list__item--no-values': count?.[group.key]?.[option.key] === 0
							}"
						>
							<cjm-checkbox
								[formControlName]="option.key"
								[id]="option.value.id"
								[title]="option.value.name"
								[label]="option.value.name"
								>{{ option.value.name }}
								<span class="c-filter-bar__facet__list__item__amount" aria-live="polite"
									>({{ count?.[group.key]?.[option.key] }})</span
								></cjm-checkbox
							>
						</li>
					}
				</ul>
			</div>
		}
	</form>
}

<ng-content select="[bottomSlot]" />
